import { Input } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FieldComponentProps } from "./types";

export function FieldText(props: FieldComponentProps): ReactNode {
  return (
    <Input
      id={props.id}
      name={props.label}
      onChange={(event) => {
        props.updateValue({ label: props.label, value: event.target.value });
      }}
      type={props.type}
      value={props.value}
    />
  );
}
